import { Link } from "react-router-dom";


import { Text, H4, Button, Small } from '@bigcommerce/big-design';

const WroListItem = ({ order, setShowRemoveWroDialog, setModifyItemId }) => {
  const setAndShowDialog = () => {
    setModifyItemId(order.id);
    setShowRemoveWroDialog(true);
  }

  return(
    <div className="has-hover sku-line flex-container">
      <div className="flex-1">
        <H4>Invoice: {order.purchase_order.invoice_number || order.purchase_order.id}</H4>
        <Small>
          <strong>Received</strong>: {order.received_at}
          <br/>
          <strong>Location</strong>: {order.purchase_order.ship_to_address.label}
        </Small>
      </div>
 
      <div className="flex-1">
        { order.warehouse_receiving_order_lines.map(line =>
            <>
              <Text>
                { line.purchase_order_line.source_name } <Small as="span"> x { line.count } </Small>
                <div className="left-15">
                  { line.purchase_order_line.source_options && line.purchase_order_line.source_options.map(option =>
                      <li>
                        <strong>{ option.option_display_name }</strong>: { option.label }
                      </li>
                    )
                  }
                </div>
              </Text>
            </>
          )
        }
      </div>

      <div className="flex-1">
        <Link to={`/print_wro/${encodeURI(order.id)}`}>
          <Button>View and Print</Button>
        </Link>

        <span className="left-15">
          <Button onClick={() => setAndShowDialog()} actionType="destructive">Remove</Button>
        </span>
      </div>
    </div>
  )
}

export default WroListItem;
